export default "__VITE_ASSET__BNqASvce__"